import { Pointer } from '@yleisradio/areena-types';
import { idFromPointer } from '../utils/pointer';

export const impressionDataAttributeKeys = {
  impressionViewDataLocation: 'data-impression-list-source',
  impressionYleId: 'data-impression-yleid',
  impressionAnalyticsContextJson: 'data-impression-analytics-context-json',
} as const;

type Params = {
  listIndex: number;
  cardIndex: number;
  pointer: Pointer | undefined;
  /** Analytics context labels */
  comscore: Record<string, string> | undefined;
};

type ImpressionDataAttributes = Record<
  (typeof impressionDataAttributeKeys)[keyof typeof impressionDataAttributeKeys],
  string | undefined
>;

export const getDataAttributesImpression = ({
  listIndex,
  cardIndex,
  pointer,
  comscore,
}: Params): ImpressionDataAttributes => {
  return {
    [impressionDataAttributeKeys.impressionViewDataLocation]: `${listIndex}:${cardIndex}`,
    [impressionDataAttributeKeys.impressionYleId]: pointer
      ? idFromPointer(pointer)
      : undefined,
    [impressionDataAttributeKeys.impressionAnalyticsContextJson]:
      comscore && JSON.stringify(comscore),
  };
};
